function getConfigCompoment () { return 'OzonConfigCompoment' }
function getStandardAttributes () {
  return []
}

export default {
  hasExecutions: () => true,
  getConfigCompoment,
  getStandardAttributes
}
